import React, { useMemo } from 'react';
import { Typography, Popover } from '@material-ui/core';
import { useStyles } from './styles';

import { ICollapsibleListProps } from './interfaces';

const CollapsibleList: React.FC<ICollapsibleListProps> = ({
  items,
  mainItemId,
  idPropName = 'code',
  valuePropName = 'description',
}: ICollapsibleListProps) => {
  if (!items.length) return null;

  const classes = useStyles();

  const alwaysShownItem =
    items.find((item) => item[idPropName] === mainItemId) || items[0];
  const hiddenItems = useMemo(
    () =>
      items.filter((item) => item[idPropName] !== alwaysShownItem[idPropName]),
    [items, alwaysShownItem, idPropName],
  );

  const textToShow = useMemo(
    () =>
      hiddenItems.length
        ? `${alwaysShownItem[valuePropName]}...`
        : alwaysShownItem[valuePropName],
    [alwaysShownItem, hiddenItems.length, valuePropName],
  );

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    (document.activeElement as HTMLElement).blur();
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Typography
        aria-owns={isOpen ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {textToShow}
      </Typography>
      {items.length ? (
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={isOpen}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {/*hiddenItems.map((item) => (
            <Typography key={item[idPropName]}>
              {item[valuePropName] + ';'}
            </Typography>
          ))*/}
          <Typography>
            {items.map((item) => item[valuePropName] + '; ')}
          </Typography>
        </Popover>
      ) : null}
    </div>
  );
};

export { CollapsibleList };
export default CollapsibleList;
